@if ({durationDisplay: durationDisplay$ | async}; as state) {
  <button [matMenuTriggerFor]="menu" class="duration-button" [class.light-background]="lightBackground">
    {{ state.durationDisplay }}
  </button>
  <mat-menu
    #menu="matMenu"
    class="task-slider-menu"
    (closed)="menuOpen = false"
    [overlapTrigger]="false"
    xPosition="after"
  >
    <div class="slider-container">
      <mat-slider min="0" [max]="durationOptions$.value.length - 1" step="1" showTickMarks>
        <input (input)="onSliderChange($any($event.target).value)" matSliderThumb [value]="sliderValue$ | async" />
      </mat-slider>
    </div>
  </mat-menu>
}
